export enum Color {
  sun = 'sun',
  cork = 'cork',
  white = 'white',
  pink = 'pink',
  darkPink = 'darkPink',
  black = 'black',
  secondary = 'secondary',
  transparent = 'transparent',
}

export const ColorValues = Object.values(Color)
export type ColorArray = typeof ColorValues
export type TypeColor = ColorArray[number]

const primaryColor50 = '#FFA300'
const primaryColor20 = '#FFF3DD'
const tertiraryColor20 = '#D6998D'
const secondaryColor10 = '#F7C1B7'
const whiteColor = '#FFFFFF'
const blackColor = '#53565A'
const transparentColor = '#FFFFFF00'

export type ColorMappingType = {
  [key in Color]: string;
};

/* ENABLE */
export enum ColorMappingBG {
  white = whiteColor,
  sun = primaryColor50,
  cork = primaryColor50,
  pink = secondaryColor10,
  darkPink = secondaryColor10,
  black = blackColor,
  secondary = blackColor,
  transparent = transparentColor,
}

export enum ColorMappingIcon {
  white = whiteColor,
  sun = primaryColor50,
  cork = whiteColor,
  pink = blackColor,
  darkPink = blackColor,
  black = blackColor,
  secondary = blackColor,
  transparent = transparentColor,
}

/* ENABLE DISABLE */
export enum ColorMappingBGDISABLE {
  white = primaryColor20,
  sun = whiteColor,
  cork = whiteColor,
  pink = whiteColor,
  darkPink = whiteColor,
  black = whiteColor,
  secondary = blackColor,
  transparent = transparentColor,
}

export enum ColorMappingIconDISABLE {
  white = whiteColor,
  sun = tertiraryColor20,
  cork = tertiraryColor20,
  pink = tertiraryColor20,
  darkPink = tertiraryColor20,
  black = tertiraryColor20,
  secondary = blackColor,
  transparent = transparentColor,
}
